import { HYDRATE } from 'next-redux-wrapper';

import { ApiResources } from 'types/apiResources';

import User from 'models/User';

import { FAIL_FLAG, INIT_FLAG, SUCCESS_FLAG } from 'consts/redux';

import * as types from './types';

export interface State {
    authToken?: string;
    refreshToken?: string;
    profile?: User;
}

export const initialState = {
    authToken: null,
    refreshToken: null,
    profile: null,
};

export default function UserReducer(state: State = initialState, action: any): any {
    switch (action.type) {
        case HYDRATE:
            // Attention! This will overwrite client state! Real apps should use proper reconciliation.
            return { ...state, ...action.payload };

        case types.SET_AUTH_TOKEN:
            return {
                ...state,
                authToken: action.payload.authToken,
                refreshToken: action.payload.refreshToken,
            };

        case types.LOGIN + '_' + INIT_FLAG:
            return {
                ...state,
                authToken: null,
                refreshToken: null,
            };

        case types.LOGIN + '_' + SUCCESS_FLAG:
        case types.PASSWORD_SET + '_' + SUCCESS_FLAG:
        case types.REGISTER + '_' + SUCCESS_FLAG:
        case types.REGISTER_COMPANY + '_' + SUCCESS_FLAG:
        case types.ACTIVATION + '_' + SUCCESS_FLAG:
            return {
                ...state,
                authToken: action.payload?.data?.authToken,
                refreshToken: action.payload?.data?.refreshToken,
                profile: new User(action.payload?.data[ApiResources.Me]),
            };

        case types.LOGIN + '_' + FAIL_FLAG:
            return {
                ...state,
                authToken: null,
                refreshToken: null,
            };

        case types.LOGOUT + '_' + SUCCESS_FLAG:
            return {
                ...state,
                authToken: null,
                refreshToken: null,
                profile: null,
            };
        case types.LOGOUT + '_' + FAIL_FLAG:
            return {
                ...state,
                authToken: null,
                refreshToken: null,
                profile: null,
            };

        case types.PROFILE_GET + '_' + SUCCESS_FLAG:
            return {
                ...state,
                profile: new User(action.payload.data[ApiResources.Me]),
            };

        default:
            return state;
    }
}
